/**
 * Visually hidden but available to assistive technology.
 *
 * `display: none` and `visibility: hidden` both remove a node from the accessibility tree, so a live
 * region hidden either way is never announced. The clip-rect idiom keeps it rendered and reachable.
 *
 * Extracted from `LoginHistoryTab` (T055) when the live region moved up to the shell (T069).
 */
export const SCREEN_READER_ONLY = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  // Pinned, not static: without these the box lays out at its static offset in the initial containing block and grows the document.
  left: 0,
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute" as const,
  top: 0,
  whiteSpace: "nowrap" as const,
  width: "1px"
};
